import axios from 'axios';
import store from '../store';
import { LOGOUT_CLIENT } from '../actions/types';
import { recordarDestino, rutaDe } from './destinoAlEntrar';

// Crear una instancia de axios con configuración base
const getBaseURL = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) return '';
  
  // Si estamos en HTTPS pero la URL es HTTP, intentamos adaptarla si es localhost
  if (window.location.protocol === 'https:' && envUrl.startsWith('http://localhost')) {
    // Nota: A veces localhost en http es permitido desde https, 
    // pero si falla, el usuario debería habilitar https en el backend.
    return envUrl;
  }
  return envUrl;
};

const backendAxios = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor global de respuestas
backendAxios.interceptors.response.use(
  (response) => {
    // Renovación silenciosa: el backend manda un token fresco cuando el actual
    // está por caducar; se reemplaza sin que el usuario lo note.
    const renovado = response.headers['x-token-refresh'];
    if (renovado) {
      localStorage.setItem('token', renovado);
      backendAxios.defaults.headers.common['x-auth-token'] = renovado;
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      // Verificar si había token antes de limpiar (distingue sesión expirada de usuario no logueado)
      const teniaToken = !!localStorage.getItem('token');

      localStorage.removeItem('token');
      delete backendAxios.defaults.headers.common['x-auth-token'];

      // Limpiar el estado de Redux para que la UI refleje que no hay sesión
      store.dispatch({ type: LOGOUT_CLIENT });

      // Solo redirigir si el token expiró estando logueado, no en el arranque inicial sin sesión
      if (teniaToken && window.location.pathname !== '/login') {
        // Al volver a entrar regresa a esta pantalla
        recordarDestino(rutaDe(window.location));
        window.location.href = '/login';
      }
      // El 401 ya se manejó (sesión ausente o expirada). Es esperado al abrir la app sin
      // sesión, así que no se loguea como error para no ensuciar la consola.
      return Promise.reject(error);
    }

    // Para cualquier otro error, solo loguear y dejar que cada action lo maneje
    console.error('Error en solicitud:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default backendAxios;